@if (agent$ | async; as agent) {
  <section class="card min-h-full">
    <!-- header -->
    <h2 class="flex gap-3 items-center">
      <span class="material-symbols-rounded cursor-pointer" routerLink="../"
        >arrow_back</span
      >
      Editar agente – {{ agent.name }}
    </h2>

    <nav class="flex gap-1 overflow-auto">
      @for (tab of tabs; track tab.id) {
        <a
          class="blu-tab-item"
          [routerLink]="[tab.id]"
          routerLinkActive="active">
          <span class="material-symbols-rounded">{{ tab.icon }}</span>
          {{ tab.label }}
        </a>
      }
    </nav>

    <hr class="m-0" />

    <!-- body -->
    <div class="flex flex-col gap-4 flex-1">
      <router-outlet></router-outlet>
    </div>

    <hr class="m-0" />

    <!-- footer -->
    <div class="flex gap-2">
      <button class="tertiary" (click)="deleteAgent()" [disabled]="loading">
        Deletar
      </button>
      <button
        class="secondary ml-auto"
        [routerLink]="['/admin/chat/agents']"
        [disabled]="loading">
        Cancelar
      </button>
      <button (click)="save()" [disabled]="!agent.name || loading">
        {{ loading ? 'Salvando...' : 'Salvar' }}
      </button>
    </div>
  </section>
} @else {
  <section class="card min-h-full">
    <div
      class="max-w-80 min-h-80 text-center flex flex-col items-center gap-4 justify-center m-auto">
      <h1>Agente não encontrado</h1>
      <p class="leading-snug text-black/60">
        O agente que você está procurando não existe ou foi removido.
      </p>
      <button class="secondary" [routerLink]="['/admin/chat/agents']">
        Voltar para agentes
      </button>
    </div>
  </section>
}
